/**
 * Created by sxp23 on 2/1/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import {AutoCompleteModule} from 'primeng/autocomplete';

import { AppRoutingModule } from './../app-routing.module';
import { CommonService} from './../common.service'
import { LocationComponent } from './location.component'


@NgModule({
  declarations: [LocationComponent],
  imports: [BrowserModule,CommonModule, AppRoutingModule, FormsModule,AutoCompleteModule],
  providers: [CommonService],
  exports: [ LocationComponent ],
  bootstrap: [ LocationComponent ],
})

export class LocationModule { }
